var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBag = function SvgBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "data-name": "Layer 1",
    viewBox: "0 0 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.68 47.71a14.64 14.64 0 0 0-14.62-14.62h-3.91a3.7 3.7 0 0 0-.59-.79L76.34 15.49a3.5 3.5 0 0 0-4.89 5l12.9 12.59H41.51L54.4 20.5a3.5 3.5 0 1 0-4.89-5L32.3 32.3a3.4 3.4 0 0 0-.59.79h-3.92a14.6 14.6 0 0 0-6.22 27.82c.35 4.54 1.19 13.71 2.83 23.25 4.36 25.44 10.34 30.11 14.46 31.41l.51.17h45.88l.52-.17c4.11-1.3 10.09-6 14.45-31.41 1.58-9.18 2.42-18 2.79-22.72a14.62 14.62 0 0 0 9.67-13.73m-28.63 61H40.57c-5.3-2.68-10.16-25-11.89-46.42h67.26c-1.73 21.47-6.58 43.77-11.89 46.45Zm14-53.42H27.79a7.62 7.62 0 0 1 0-15.23h70.27a7.62 7.62 0 1 1 0 15.23Z",
    className: "bag_svg__cls-1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8.11,
    height: 22.34,
    x: 47.79,
    y: 70.16,
    className: "bag_svg__cls-1",
    rx: 2.65
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8.11,
    height: 22.34,
    x: 68.72,
    y: 70.16,
    className: "bag_svg__cls-1",
    rx: 2.65
  })));
};
export default SvgBag;